import { message } from 'antd'
import { useEffect } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { API_URL } from '../../api/ApiWrapper'
import Auth from '../../modules/Authentication'

const auth = new Auth()

export default function useFetch({
  url = '',
  queryKey = url,
  mapFunction,
  dataFunction,
  dependencyArray = [],
  dontFetch = false,
  isExternal = false,
  suppressAlert = false,
  staleTime = 1000 * 60 * 30, // 30 min,
}) {
  const queryClient = useQueryClient()

  const fullURL = (isExternal ? url : API_URL + url).replace('//', '/')

  const accessToken = auth.getAccessToken()
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    authorization: accessToken ? `Bearer ${accessToken}` : undefined,
  }

  async function fetchURL() {
    const response = await fetch(fullURL, { headers })
    const data = await response.json()

    if (!response.ok && !suppressAlert) {
      const error = data.message || `${url} is ${response.statusText}` || 'Error'
      console.log(data)
      console.error(error)
      throw {
        error,
        data,
      }
    }
    let newData = mapFunction ? data.map(mapFunction) : data

    return dataFunction ? dataFunction(newData) : newData
  }

  const query = useQuery(queryKey, fetchURL, {
    staleTime,
    enabled: !dontFetch,
    refetchOnWindowFocus: false,
    onError: ({ error }) => message.error(error),
  })

  // useEffect(() => {
  //   queryClient.invalidateQueries(queryKey)
  // }, [dependencyArray])

  return {
    ...query,
    data: query.data || [],
    fetching: query.isLoading,
    isFetching: query.isFetching,
    fetch: () => queryClient.invalidateQueries(queryKey),
  }
}
